module.exports = __webpack_public_path__ + "img/hint-four-mobile-eng.8540e759.png";